/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Audit_SinceInputs */

const cs_gdpr_audit_since = /** @type {(inputs: Gdpr_Audit_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od`)
};

const en_gdpr_audit_since = /** @type {(inputs: Gdpr_Audit_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Gdpr_Audit_SinceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_since = /** @type {((inputs?: Gdpr_Audit_SinceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_SinceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_since(inputs)
	return cs_gdpr_audit_since(inputs)
});